import { ApiSmsTemplate, ApiWhatsappTemplate } from "./interface.api";
import { SmsTemplate, WhatsappTemplate } from "@/types";

export const smsTemplateMapper = (api: ApiSmsTemplate): SmsTemplate => {
  return {
    id: api.MessageTemplateId,
    subject: api.Title,
    text: api.MessageText
  }
}

export const smsTemplatesMapper = (api: ApiSmsTemplate[]): SmsTemplate[] => {
    return api.map((smsTemplate) => smsTemplateMapper(smsTemplate))
  }

export const whatsappTemplateMapper = (api: ApiWhatsappTemplate): WhatsappTemplate => {
  return {
    id: api.WhatsappMessageTemplateId,
    subject: api.Title,
    text: api.MessageText
  }
}

export const whatsappTemplatesMapper = (api: ApiWhatsappTemplate[]): WhatsappTemplate[] => {
    return api.map((whatsappTemplate) => whatsappTemplateMapper(whatsappTemplate))
  }